export default {
  HEALTH: 'HE',
  FITNESS: 'FN',
};
